import {
  BrowserRouter as Router,
  Routes,
  Route
 } from "react-router-dom";
 

import './App.css';
import Header from './components/Header';
import Init from './pages/Init';
import SearchByPhoto from './pages/SearchByPhoto';
import Loading from './pages/Loading';
import Error from './pages/Error'
import Result from './pages/Result'
import AllTires from './pages/AllTires'
import Feedback from './pages/Feedback'

function App() {
  return (
    <div>
      <Header />
      <Router>
        <Routes>
          <Route path="/" element={<Init />} />
          <Route path="searchbyphoto" element={<SearchByPhoto />} />
          <Route path="loading" element={<Loading />} />
          <Route path="error" element={<Error />} />
          <Route path="result" element={<Result />} />
          <Route path="alltires" element={<AllTires />} />
          <Route path="feedback" element={<Feedback />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
